const basicPersonalLeadsPath = (routePath = '') =>
  `personal-campaign-leads${routePath && '/'}${routePath}`;

export const generateOutreachEmail = (leadId: string) =>
  basicPersonalLeadsPath(`${leadId}/generate-outreach-email`);
export const getLeadById = (leadId: string) => basicPersonalLeadsPath(leadId);
export const confirmLead = (leadId: string) =>
  basicPersonalLeadsPath(`${leadId}/confirm`);
export const declineLead = (leadId: string) =>
  basicPersonalLeadsPath(`${leadId}/decline`);
